












import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";

@Component
export default class JobSlider extends Vue {
    @Prop() counts!: any;

    @Ref() readonly sliderEl!: HTMLElement;

    slider: any = null;

    private mounted() {
        this.initSlider();
    }

    private initSlider() {
        this.$nextTick(() => {
            // @ts-nocheck
            this.slider = tns({
                container: this.sliderEl,
                items: 1.3,
                gutter: 24,
                fixedWidth: 280,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                swipeAngle: false,
                nav: false,
                responsive: {
                    1400: {
                        gutter: 60,
                        items: 5
                    }
                }
            });
        });
    }
}
